module.exports = __webpack_public_path__ + "media/images/og-55bc7b99d91f070ba40f4b84918ce00b.png";